import { applyThemeVariables } from './apply-theme-variables';
import { formatColor, formatBorder, formatFont, formatGeneric, formatNumeric } from './formatters';
import { getRuleForType } from './rules';
export const resolveStyleCSSValue = (value, _ref) => {
  let {
    themeVariables
  } = _ref;
  if (!value.defaultValue) {
    return undefined;
  }
  const applyTheme = value => applyThemeVariables(value, themeVariables);
  const rule = getRuleForType(value.type);
  if (rule) {
    switch (rule.type) {
      case 'color':
        return formatColor(value.defaultValue, applyTheme);
      case 'border':
        return formatBorder(value.defaultValue, applyTheme);
      case 'font':
        return formatFont(value.defaultValue, applyTheme);
      case 'stringOrNumber':
        return formatNumeric({
          value: value.defaultValue,
          unit: rule.unit
        }, value => applyThemeVariables(value, themeVariables));
      case 'string':
      case 'boolean':
      default:
        return formatGeneric(value.defaultValue, applyTheme);
    }
  }
  return formatGeneric(value.defaultValue, applyTheme);
};
//# sourceMappingURL=resolve-style-css-value.js.map